module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h1', {
    staticClass: "chapter"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/listofmap.htm"
    }
  }, [_c('em', [_vm._v("List of Maps")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/acknow.htm"
    }
  }, [_c('em', [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/anote.htm"
    }
  }, [_c('em', [_vm._v("A Note on Transliteration and Dating")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/intro.htm"
    }
  }, [_c('em', [_vm._v("Introduction")])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch01.htm"
    }
  }, [_vm._v("1. Before Islam")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch02.htm"
    }
  }, [_vm._v("2. The Prophet Mohammed and the Jews")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch03.htm"
    }
  }, [_vm._v("3. Protection or Persecution?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch04.htm"
    }
  }, [_vm._v("4. The First Four Hundred Years Under Islam")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch05.htm"
    }
  }, [_vm._v("5. Jews and Muslims in the Age of the Crusades")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch06.htm"
    }
  }, [_vm._v("6. The Ottoman Sultans and Other Muslim Rulers, 1324 015–1699")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch07.htm"
    }
  }, [_vm._v("7. The Eighteenth and Nineteenth Centuries")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch08.htm"
    }
  }, [_vm._v("8. Progress and Peril: Towards the Twentieth Century")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch09.htm"
    }
  }, [_vm._v("9. The First Years of the Twentieth Century and the Emergence of Zionism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch10.htm"
    }
  }, [_vm._v("10. Jewish and Arab Nationalism: The First World War and After")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch11.htm"
    }
  }, [_vm._v("11. The Nineteen Thirties")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch12.htm"
    }
  }, [_vm._v("12. The Second World War: A Time of Danger")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch13.htm"
    }
  }, [_vm._v("13. Towards Liberation, and an Uncertain Future")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch14.htm"
    }
  }, [_vm._v("14. The United Nations Palestine Partition Resolution")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch15.htm"
    }
  }, [_vm._v("15. The Creation of the State of Israel, 14 May 1948")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch16.htm"
    }
  }, [_vm._v("16. Iraq, 1948–1952")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch17.htm"
    }
  }, [_vm._v("17. Egypt, 1951–1961")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch18.htm"
    }
  }, [_vm._v("18. The Exodus Continues, 1950–1967")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch19.htm"
    }
  }, [_vm._v("19. The Six–Day War of 1967 and Its Aftermath")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch20.htm"
    }
  }, [_vm._v("20. A New Life in New Lands")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch21.htm"
    }
  }, [_vm._v("21. The Search for Recognition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch22.htm"
    }
  }, [_vm._v("22. Jews Who Remain in Muslim Lands")])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/map.htm"
    }
  }, [_c('em', [_vm._v("Maps")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/glos.htm"
    }
  }, [_c('em', [_vm._v("Glossary")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/bib.htm"
    }
  }, [_c('em', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/index.htm"
    }
  }, [_c('em', [_vm._v("Index")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33ef1ee3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/toc.vue
// module id = 72
// module chunks = 0